(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-audit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-pulse-audit]');
    if (!root) return;
    var form = root.querySelector('[data-audit-form]');
    if (!form) return;
    var url = form.querySelector('[data-audit-url]');
    var goalsBox = form.querySelector('[data-audit-goals]');
    var goalsVal = form.querySelector('[data-audit-goals-value]');
    var traffic = form.querySelector('[data-audit-traffic]');
    var btn = form.querySelector('[data-audit-submit]');
    function err(name, on) { var e = form.querySelector('[data-err="' + name + '"]'); if (e) e.hidden = !on; }
    function checkedGoals() {
      return Array.prototype.map.call(goalsBox ? goalsBox.querySelectorAll('input:checked') : [], function (i) { return i.value; });
    }
    function normUrl(v) {
      v = (v || '').trim();
      if (!v) return '';
      if (!/^https?:\/\//i.test(v)) v = 'https://' + v;
      return v;
    }
    function validUrl(v) { return /^https?:\/\/[^\s.]+\.[^\s]{2,}/i.test(v); }
    function capGoals() {
      if (!goalsBox) return;
      var max = parseInt(goalsBox.getAttribute('data-max'), 10) || 0;
      if (!max) return;
      var full = checkedGoals().length >= max;
      goalsBox.querySelectorAll('input').forEach(function (i) { if (!i.checked) i.disabled = full; });
    }
    if (goalsBox) goalsBox.addEventListener('change', function () { capGoals(); if (checkedGoals().length) err('goals', false); });
    capGoals();
    if (url) url.addEventListener('input', function () { err('url', false); });
    if (traffic) traffic.addEventListener('change', function () { err('traffic', false); });

    /* Capture phase on document: runs before the header's cart-drawer handler that
       is bound directly to every /cart/add form, so this purchase skips the drawer. */
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      e.preventDefault();
      e.stopPropagation();
      var u = normUrl(url && url.value), goals = checkedGoals(), ok = true;
      if (!validUrl(u)) { err('url', true); ok = false; }
      if (!goals.length) { err('goals', true); ok = false; }
      if (traffic && !traffic.value) { err('traffic', true); ok = false; }
      if (!ok) {
        var first = form.querySelector('.pulse-audit__error:not([hidden])');
        if (first && first.parentNode.scrollIntoView) first.parentNode.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      if (url) url.value = u;
      /* Instagram handles: store as @handle; drop empty optional fields so the order stays clean */
      form.querySelectorAll('[data-audit-ig]').forEach(function (f) {
        var v = (f.value || '').trim().replace(/^https?:\/\/(www\.)?instagram\.com\//i, '').replace(/\/.*$/, '').replace(/^@+/, '');
        if (v) { f.value = '@' + v; f.setAttribute('name', f.getAttribute('data-name') || f.name); }
        else { if (!f.getAttribute('data-name')) f.setAttribute('data-name', f.name); f.removeAttribute('name'); }
      });
      if (goalsVal) goalsVal.value = goals.join(', ');
      err('form', false);
      if (btn) btn.classList.add('is-loading');
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
        .catch(function () { if (btn) btn.classList.remove('is-loading'); err('form', true); });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-community"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pulse-community]').forEach(function (root) {
    var track = root.querySelector('[data-pulse-ctrack]');
    if (!track) return;
    var step = function () { return Math.max(track.clientWidth * 0.8, 260); };
    var prev = root.querySelector('[data-pulse-cprev]');
    var next = root.querySelector('[data-pulse-cnext]');
    var rtlSign = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * rtlSign, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * rtlSign, behavior: 'smooth' }); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-demos"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pulse-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var val = btn.getAttribute('data-pulse-copy') || '';
      var done = function () {
        btn.classList.add('is-copied');
        setTimeout(function () { btn.classList.remove('is-copied'); }, 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(val).then(done).catch(done);
      } else {
        var t = document.createElement('textarea');
        t.value = val; t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.focus(); t.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(t); done();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.body.classList.add('pulse-vsl');
    document.querySelectorAll('[data-pulse-header]').forEach(function (root) {
      var burger = root.querySelector('[data-pulse-burger]');
      var panel = root.querySelector('[data-pulse-mobile]');
      if (!burger || !panel) return;
      burger.addEventListener('click', function () {
        var open = burger.getAttribute('aria-expanded') === 'true';
        burger.setAttribute('aria-expanded', String(!open));
        if (open) { panel.setAttribute('hidden', ''); } else { panel.removeAttribute('hidden'); }
      });
    });

    /* ---------- Cursor glow (desktop only) ---------- */
    (function () {
      if (window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches) return;
      var glow = document.querySelector('[data-cursorglow]');
      if (!glow) return;
      /* lift it out of the section so it isn't trapped in #MainContent's stacking context */
      document.body.appendChild(glow);
      var raf, gx = 0, gy = 0;
      window.addEventListener('mousemove', function (e) {
        gx = e.clientX; gy = e.clientY;
        if (!raf) raf = requestAnimationFrame(function () {
          raf = null;
          glow.style.transform = 'translate(' + gx + 'px, ' + gy + 'px)';
          if (!document.body.classList.contains('cursorglow-on')) document.body.classList.add('cursorglow-on');
        });
      }, { passive: true });
    })();

    /* ---------- Cart drawer (renders from /cart.js — no Section Rendering) ---------- */
    (function () {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) return;
      var body = drawer.querySelector('[data-cart-body]');
      var foot = drawer.querySelector('[data-cart-foot]');
      var moneyFormat = (drawer.getAttribute('data-money-format') || '${{amount}}').replace(/<[^>]+>/g, '');
      var I18N = {
        empty: drawer.getAttribute('data-i18n-empty') || 'Your cart is empty',
        remove: drawer.getAttribute('data-i18n-remove') || 'Remove item',
        decrease: drawer.getAttribute('data-i18n-decrease') || 'Decrease',
        increase: drawer.getAttribute('data-i18n-increase') || 'Increase',
        save: drawer.getAttribute('data-i18n-save') || 'You save'
      };

      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
      function money(cents) {
        cents = cents || 0;
        function fmt(precision, thousands, decimal) {
          var num = (cents / 100).toFixed(precision);
          var parts = num.split('.');
          var dollars = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
          return parts[1] ? dollars + decimal + parts[1] : dollars;
        }
        return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
          switch (name) {
            case 'amount_no_decimals': return fmt(0, ',', '.');
            case 'amount_with_comma_separator': return fmt(2, '.', ',');
            case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
            case 'amount_with_space_separator': return fmt(2, ' ', ',');
            default: return fmt(2, ',', '.');
          }
        });
      }
      function sized(url) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=180' : ''; }

      var TRASH = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16M9 7V5.2a1.2 1.2 0 0 1 1.2-1.2h3.6A1.2 1.2 0 0 1 15 5.2V7M6.5 7l.8 11.4a1.4 1.4 0 0 0 1.4 1.3h6.6a1.4 1.4 0 0 0 1.4-1.3L17.5 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var FIXED_HANDLE = drawer.getAttribute('data-cart-fixed-handle') || '';
      var FIXED_IMAGE = drawer.getAttribute('data-cart-fixed-image') || '';
      function thumbSrc(it) {
        if (FIXED_HANDLE && FIXED_IMAGE && it.handle === FIXED_HANDLE) return FIXED_IMAGE;
        return it.image ? sized(it.image) : '';
      }
      function render(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (el.classList.contains('pulse-hdr__count')) el.hidden = (cart.item_count === 0);
        });
        if (cart.item_count === 0) {
          body.innerHTML = '<div class="pulse-cart__empty"><p>' + esc(I18N.empty) + '</p></div>';
          if (foot) foot.hidden = true;
          return;
        }
        if (foot) foot.hidden = false;
        var sub = drawer.querySelector('[data-cart-subtotal]');
        if (sub) {
          sub.innerHTML = (cart.original_total_price > cart.total_price ? '<s>' + money(cart.original_total_price) + '</s>' : '')
            + '<b>' + money(cart.total_price) + '</b>';
        }
        var save = drawer.querySelector('[data-cart-save]');
        if (save) {
          var disc = cart.total_discount || 0;
          save.hidden = disc <= 0;
          if (disc > 0) save.innerHTML = esc(I18N.save) + ' <b>' + money(disc) + '</b>';
        }
        var html = '<ul class="pulse-cart__items">';
        cart.items.forEach(function (it) {
          var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? '<p class="pulse-cart__variant">' + esc(it.variant_title) + '</p>' : '';
          html += '<li class="pulse-cart__item" data-key="' + esc(it.key) + '">'
            + '<a href="' + esc(it.url) + '" class="pulse-cart__thumb">' + (thumbSrc(it) ? '<img src="' + esc(thumbSrc(it)) + '" alt="' + esc(it.product_title) + '" width="70" height="86" loading="lazy">' : '') + '</a>'
            + '<div class="pulse-cart__info">'
            + '<div class="pulse-cart__row1"><p class="pulse-cart__name">' + esc(it.product_title) + '</p>'
            + '<button type="button" class="pulse-cart__remove" data-remove aria-label="' + esc(I18N.remove) + '">' + TRASH + '</button></div>'
            + variant
            + '<div class="pulse-cart__row2"><div class="pulse-cart__qty">'
            + '<button type="button" data-qty="dec" aria-label="' + esc(I18N.decrease) + '">&minus;</button>'
            + '<span data-qty-val>' + it.quantity + '</span>'
            + '<button type="button" data-qty="inc" aria-label="' + esc(I18N.increase) + '">+</button></div>'
            + '<span class="pulse-cart__price">'
            + (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '')
            + '<b>' + money(it.final_line_price) + '</b></span></div>'
            + '</div></li>';
        });
        body.innerHTML = html + '</ul>';
      }

      function fetchCart(cb) {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { render(c); if (cb) cb(); })
          .catch(function () { if (cb) cb(); });
      }
      function openCart() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
      function closeCart() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }

      document.querySelectorAll('[data-cart-toggle]').forEach(function (t) {
        t.addEventListener('click', function (e) { e.preventDefault(); fetchCart(); openCart(); });
      });
      drawer.addEventListener('click', function (e) { if (e.target.closest('[data-cart-close]')) closeCart(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

      drawer.addEventListener('click', function (e) {
        var qbtn = e.target.closest('[data-qty]');
        var rbtn = e.target.closest('[data-remove]');
        var item = e.target.closest('[data-key]');
        if (!item) return;
        var key = item.getAttribute('data-key');
        if (qbtn) {
          var val = item.querySelector('[data-qty-val]');
          var n = parseInt(val ? val.textContent : '1', 10) || 1;
          n = qbtn.getAttribute('data-qty') === 'inc' ? n + 1 : n - 1;
          change(key, Math.max(0, n));
        } else if (rbtn) {
          change(key, 0);
        }
      });

      function change(key, qty) {
        drawer.classList.add('is-busy');
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
          .then(function (r) { return r.json(); })
          .then(function (cart) { render(cart); drawer.classList.remove('is-busy'); })
          .catch(function () { drawer.classList.remove('is-busy'); });
      }

      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('[name="add"]');
          if (btn) btn.classList.add('is-loading');
          openCart(); /* open immediately — don't wait on the network */
          body.innerHTML = '<div class="pulse-cart__loading"><span class="pulse-cart__spinner"></span></div>';
          fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
            .then(function (r) { if (!r.ok) throw 0; return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
            .then(function (r) { return r.json(); })
            .then(function (cart) { render(cart); if (btn) btn.classList.remove('is-loading'); })
            .catch(function () { if (btn) btn.classList.remove('is-loading'); form.submit(); });
        });
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pulse-play]').forEach(function (btn) {
    var vid = btn.parentNode.querySelector('[data-pulse-vid]');
    if (!vid) return;
    btn.addEventListener('click', function () {
      vid.setAttribute('controls', '');
      btn.hidden = true;
      var p = vid.play(); if (p && p.catch) p.catch(function () {});
    });
    vid.addEventListener('play', function () { btn.hidden = true; vid.setAttribute('controls', ''); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-home-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hhero]').forEach(function (root) {
    var words = root.querySelectorAll('[data-word]');
    if (words.length < 2) return;
    var i = 0;
    setInterval(function () {
      var cur = words[i];
      i = (i + 1) % words.length;
      var next = words[i];
      cur.classList.remove('is-active');
      cur.classList.add('is-out');
      next.classList.remove('is-out');
      next.classList.add('is-active');
      setTimeout(function () { cur.classList.remove('is-out'); }, 520);
    }, 2600);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-pfeatures"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pulse-pfeatures] .pulse-pfeat').forEach(function (card) {
    var track = card.querySelector('[data-pulse-track]');
    var dots = card.querySelectorAll('[data-pulse-dot]');
    if (!track || !dots.length) return;

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-pulse-dot'), 10);
        track.scrollTo({ left: (getComputedStyle(track).direction === 'rtl' ? -1 : 1) * track.clientWidth * i, behavior: 'smooth' });
      });
    });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pulse-product]').forEach(function (root) {
    var gtrack = root.querySelector('[data-pulse-gtrack]');
    var thumbs = root.querySelectorAll('[data-pulse-thumb]');
    /* The track is a flex row, so its natural height is the TALLEST slide. Size the
       stage to the slide actually in view so the thumbnails sit right under it. */
    var stage = root.querySelector('.pulse-product__stage');
    var slides = gtrack ? gtrack.querySelectorAll('.pulse-product__slide') : [];
    function dirSign(el) { return getComputedStyle(el).direction === 'rtl' ? -1 : 1; }
    function activeIndex() { return Math.round(Math.abs(gtrack.scrollLeft) / gtrack.clientWidth); }
    function fitStage() {
      if (!stage || !slides.length) return;
      var img = slides[Math.min(activeIndex(), slides.length - 1)].querySelector('img');
      if (img && img.offsetHeight) stage.style.height = img.offsetHeight + 'px';
    }
    if (gtrack && slides.length) {
      fitStage();
      slides.forEach(function (sl) { var im = sl.querySelector('img'); if (im && !im.complete) im.addEventListener('load', fitStage, { once: true }); });
      window.addEventListener('resize', fitStage);
    }
    if (gtrack && thumbs.length) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var i = parseInt(thumb.getAttribute('data-pulse-thumb'), 10) || 0;
          gtrack.scrollTo({ left: dirSign(gtrack) * gtrack.clientWidth * i, behavior: 'smooth' });
        });
      });
      var graf;
      gtrack.addEventListener('scroll', function () {
        if (graf) return;
        graf = requestAnimationFrame(function () {
          graf = null;
          var i = activeIndex();
          thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
          fitStage();
        });
      });
    }

    /* testimonial slider — native scroll-snap does the moving; this just syncs dots,
       wires the arrows, and auto-advances when nobody is interacting */
    var tm = root.querySelector('[data-pulse-tm]');
    if (tm) {
      var tmTrack = tm.querySelector('[data-tm-track]');
      var tmSlides = tmTrack ? tmTrack.querySelectorAll('.pulse-product__founder') : [];
      var tmDots = tm.querySelectorAll('[data-tm-dot]');
      var tmReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function tmIndex() { return Math.round(Math.abs(tmTrack.scrollLeft) / tmTrack.clientWidth); }
      function tmGo(i) {
        var n = tmSlides.length; if (!n) return;
        i = ((i % n) + n) % n;
        tmTrack.scrollTo({ left: dirSign(tmTrack) * tmTrack.clientWidth * i, behavior: tmReduce ? 'auto' : 'smooth' });
      }
      function tmSync() { var i = tmIndex(); tmDots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); }); }
      tmDots.forEach(function (d) { d.addEventListener('click', function () { tmGo(parseInt(d.getAttribute('data-tm-dot'), 10) || 0); }); });
      var tmPrev = tm.querySelector('[data-tm-prev]'), tmNext = tm.querySelector('[data-tm-next]');
      if (tmPrev) tmPrev.addEventListener('click', function () { tmGo(tmIndex() - 1); });
      if (tmNext) tmNext.addEventListener('click', function () { tmGo(tmIndex() + 1); });
      var tmRaf;
      if (tmTrack) tmTrack.addEventListener('scroll', function () {
        if (tmRaf) return;
        tmRaf = requestAnimationFrame(function () { tmRaf = null; tmSync(); });
      });
      tmSync();
      if (tmSlides.length > 1 && !tmReduce) {
        var tmTimer = null;
        function tmStop() { if (tmTimer) clearInterval(tmTimer); tmTimer = null; }
        function tmStart() { tmStop(); tmTimer = setInterval(function () { tmGo(tmIndex() + 1); }, 6000); }
        tm.addEventListener('mouseenter', tmStop); tm.addEventListener('mouseleave', tmStart);
        tm.addEventListener('focusin', tmStop);    tm.addEventListener('focusout', tmStart);
        tm.addEventListener('touchstart', tmStop, { passive: true });
        document.addEventListener('visibilitychange', function () { if (document.hidden) tmStop(); else tmStart(); });
        tmStart();
      }
    }

    /* licence selector — sets quantity + reflects the tier price */
    var licCards = root.querySelectorAll('[data-lic-card]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var priceNow = root.querySelector('.pulse-product__price-now');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    function applyTier(card) {
      if (qtyInput) qtyInput.value = card.getAttribute('data-qty') || '1';
      var p = card.getAttribute('data-price');
      if (p) {
        if (priceNow) priceNow.textContent = p;
        if (stickyPrice) stickyPrice.textContent = p;
      }
    }
    if (licCards.length) {
      licCards.forEach(function (card) {
        card.addEventListener('click', function () {
          licCards.forEach(function (c) { c.classList.remove('is-active'); });
          card.classList.add('is-active');
          applyTier(card);
        });
      });
      applyTier(root.querySelector('[data-lic-card].is-active') || licCards[0]);
    }

    /* sticky Add to cart — show when the main button is out of view */
    var stickyBar = root.querySelector('[data-sticky-atc]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var mainAtc = root.querySelector('.pulse-product__atc');
    if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          /* only once the button has scrolled ABOVE the viewport — not while it's
             still below (i.e. don't show it at the top of the page) */
          var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', scrolledPast);
          stickyBar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
        });
      }, { threshold: 0 }).observe(mainAtc);
    }

    var buyNow = root.querySelector('[data-buy-now]');
    var form = root.querySelector('form');

    /* sticky button submits the real form so the cart drawer still intercepts it */
    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        if (form.requestSubmit) { form.requestSubmit(); }
        else { form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
      });
    }
    if (buyNow && form) {
      buyNow.addEventListener('click', function () {
        var vid = form.querySelector('[data-pulse-vid]');
        if (!vid) { form.submit(); return; }
        buyNow.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid.value, quantity: parseInt(qtyInput && qtyInput.value, 10) || 1 })
        }).then(function () { window.location.href = '/checkout'; })
          .catch(function () { form.submit(); });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fshow]').forEach(function (root) {
    var featBtns = root.querySelectorAll('[data-feature-name]');
    var styleWrap = root.querySelector('[data-styles]');
    var styleBtns = root.querySelectorAll('[data-style-block]');
    var deviceBtns = root.querySelectorAll('[data-device-btn]');
    var panels = root.querySelectorAll('[data-panel]');
    var device = root.getAttribute('data-default-device') || 'desktop';
    var current = 0;

    function showMedia() {
      panels.forEach(function (p) {
        var on = p.getAttribute('data-panel') === String(current);
        p.classList.toggle('is-active', on);
        p.querySelectorAll('[data-media]').forEach(function (m) {
          var mon = on && m.getAttribute('data-media') === device;
          m.classList.toggle('is-active', mon);
          var v = m.querySelector('video');
          if (v) { if (mon) { try { v.currentTime = 0; v.play(); } catch (e) {} } else { v.pause(); } }
        });
      });
      syncDeviceBtns();
    }

    function selectBlock(idx) {
      current = idx;
      styleBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-style-block') === String(idx)); });
      showMedia();
    }

    function selectFeature(name) {
      featBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-feature-name') === name); });
      var visible = [];
      styleBtns.forEach(function (b) {
        var on = b.getAttribute('data-style-feat') === name;
        b.hidden = !on;
        if (on) visible.push(b);
      });
      var showStyles = visible.length > 1 || (visible.length === 1 && visible[0].getAttribute('data-has-name') === '1');
      styleWrap.hidden = !showStyles;
      if (visible.length) selectBlock(parseInt(visible[0].getAttribute('data-style-block'), 10));
    }

    /* ---- viewer (click to open; switch device inside) ---- */
    var lb = root.querySelector('[data-lb]');
    var lbMedia = root.querySelector('[data-lb-media]');
    var lbTitle = root.querySelector('[data-lb-title]');
    var lbDevBtns = root.querySelectorAll('[data-lb-device]');

    function syncDeviceBtns() {
      deviceBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-device-btn') === device); });
      lbDevBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-lb-device') === device); });
    }
    function lbOpen() { return lb && lb.classList.contains('is-open'); }

    function renderLb() {
      if (!lbMedia) return;
      var panel = root.querySelector('[data-panel="' + current + '"]');
      lbMedia.innerHTML = '';
      lbMedia.className = 'pulse-showcase__lb-media is-' + device;
      if (!panel) return;
      var src = panel.querySelector('[data-media="' + device + '"]');
      var node = src ? src.querySelector('video, img') : null;
      if (node) {
        var clone = node.cloneNode(true);
        clone.removeAttribute('data-zoom');
        if (clone.tagName === 'IMG') { var full = clone.getAttribute('data-full'); if (full) clone.src = full; }
        if (clone.tagName === 'VIDEO') {
          clone.removeAttribute('preload'); clone.muted = true; clone.loop = true; clone.playsInline = true;
          clone.setAttribute('controls', '');
        }
        lbMedia.appendChild(clone);
        if (clone.tagName === 'VIDEO') { try { clone.play(); } catch (e) {} }
      }
      if (lbTitle) {
        var sb = root.querySelector('[data-style-block="' + current + '"]');
        var feat = sb ? sb.getAttribute('data-style-feat') : '';
        var st = (sb && sb.getAttribute('data-has-name') === '1') ? sb.textContent.trim() : '';
        lbTitle.textContent = st ? feat + ' — ' + st : feat;
      }
    }
    function openLb() {
      if (!lb) return;
      lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      syncDeviceBtns(); renderLb();
    }
    function closeLb() {
      if (!lb) return;
      lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lbMedia) lbMedia.innerHTML = '';
    }
    function setDevice(d) { device = d; showMedia(); if (lbOpen()) renderLb(); }

    featBtns.forEach(function (b) { b.addEventListener('click', function () { selectFeature(b.getAttribute('data-feature-name')); }); });
    styleBtns.forEach(function (b) { b.addEventListener('click', function () { selectBlock(parseInt(b.getAttribute('data-style-block'), 10)); }); });
    deviceBtns.forEach(function (b) { b.addEventListener('click', function () { setDevice(b.getAttribute('data-device-btn')); }); });
    lbDevBtns.forEach(function (b) { b.addEventListener('click', function () { setDevice(b.getAttribute('data-lb-device')); }); });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-lb-close]')) { closeLb(); return; }
      if (e.target.closest('[data-zoom]')) { openLb(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lbOpen()) closeLb(); });

    if (featBtns.length) selectFeature(featBtns[0].getAttribute('data-feature-name'));
  });

  } catch(e) { console.error(e); }
})();
})();
